/** Avoid circular imports: ttq/ipttq services notify without importing homeTtqBurdenService at top level. */
export function notifyHomeTtqBurdenStatsInvalidated() {
  void import('./homeTtqBurdenService').then(({ invalidateHomeTtqBurdenStats }) => {
    invalidateHomeTtqBurdenStats();
  });
}
